import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useUserStore } from "../../store/userStore.js";

import {
  HomeOutlined,
  FileImageOutlined,
  EditOutlined,
  ApartmentOutlined,
  SecurityScanOutlined,
  PullRequestOutlined,
  ShoppingCartOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import images from "../../assets";

const findCurrentKeyAndParents = (items, currentPath) => {
  for (let item of items) {
    if (item.route === currentPath)
      return { currentKey: item.key, parentkeys: [] };
    if (item.children) {
      const result = findCurrentKeyAndParents(item.children, currentPath);
      if (result) {
        return {
          currentKey: result.currentKey,
          parentkeys: [item.key, ...result.parentkeys],
        };
      }
    }
  }
  return null;
};

export default function UserProfileSidebar() {
  const location = useLocation();

  const { user } = useUserStore();

  const [stateOpenKeys, setStateOpenKeys] = useState(["1"]);
  const [selectedKey, setSelectedKey] = useState("1");

  useEffect(() => {
    const current = findCurrentKeyAndParents(items, location.pathname);
    if (current) {
      setSelectedKey(current.currentKey);
      setStateOpenKeys(current.parentkeys);
    }
  }, [location.pathname]);

  const onOpenChange = (openKeys) => {
    setStateOpenKeys(openKeys);
  };

  const renderMenuItems = (menuItems) => {
    return menuItems.map((item) => {
      if (item.children) {
        return {
          ...item,
          label: <Link to={item?.route}>{item.label}</Link>,
          children: renderMenuItems(item.children),
        };
      }
      return {
        ...item,
        label: (
          <Link
            style={location.pathname === item.route ? { color: "white" } : {}}
            to={item?.route}
          >
            {item.label}
          </Link>
        ),
      };
    });
  };

  const items = [
    {
      key: "1",
      icon: <HomeOutlined />,
      label: "Overview",
      route: `/userprofileoverview/${user?.username}`,
    },
    {
      key: "2",
      icon: <FileImageOutlined />,
      label: "Photos",
      children: [
        {
          key: "21",
          label: "Pending",
          route: `/userprofileoverview/${user?.username}/photos/photospending`,
          parentkey: "2",
        },
        {
          key: "22",
          label: "Gallery",
          route: `/userprofileoverview/${user?.username}/photos/photosgallery`,
          parentkey: "2",
        },
      ],
    },
    {
      key: "3",
      icon: <EditOutlined />,
      label: "Edit Profile",
      route: `/userprofileoverview/${user?.username}/editUserProfile`,
    },
    {
      key: "4",
      icon: <ApartmentOutlined />,
      label: "Match Preferences",
      route: `/userprofileoverview/${user?.username}/editUserMatchPref`,
    },
    {
      key: "5",
      icon: <SecurityScanOutlined />,
      label: "Trust Badge",
      route: `/userprofileoverview/${user?.username}/editUserTrustBadge`,
    },
    {
      key: "6",
      icon: <PullRequestOutlined />,
      label: "User Requests",
      route: `/userprofileoverview/${user?.username}/userrequests`,
    },
    {
      key: "7",
      icon: <ShoppingCartOutlined />,
      label: "Membership",
      children: [
        {
          key: "71",
          label: "Current Plan",
          route: `/userprofileoverview/${user?.username}/membership/currentplan`,
          parentkey: "7",
        },
        {
          key: "72",
          label: "Transaction Logs",
          route: `/userprofileoverview/${user?.username}/membership/transactionlogs`,
          parentkey: "7",
        },
      ],
    },
    {
      key: "8",
      icon: <SettingOutlined />,
      label: "Settings",
      children: [
        {
          key: "81",
          label: "Activity Logs",
          route: `/userprofileoverview/${user?.username}/settings/activitylogs`,
          parentkey: "8",
        },
        {
          key: "82",
          label: "Activity Timeline",
          route: `/userprofileoverview/${user?.username}/settings/activitytimeline`,
          parentkey: "8",
        },
        {
          key: "83",
          label: "Usage Analytics",
          route: `/userprofileoverview/${user?.username}/settings/usageanalytics`,
          parentkey: "8",
        },
        {
          key: "84",
          label: "Notification Pref.",
          route: `/userprofileoverview/${user?.username}/settings/notificationpref`,
          parentkey: "8",
        },
        {
          key: "85",
          label: "Messages",
          route: `/userprofileoverview/${user?.username}/settings/messages`,
          parentkey: "8",
        },
        {
          key: "86",
          label: "Account Status",
          route: `/userprofileoverview/${user?.username}/settings/accountstatus`,
          parentkey: "8",
        },
      ],
    },
  ];

  return (
    <div className="fixed top-[170px] left-[20px] h-full w-[280px] bg-[#091E42] rounded-t-3xl">
      <div
        style={{
          backgroundImage: `url(${images.userProfileBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="w-full flex-col justify-start rounded-t-xl items-center gap-[30px] inline-flex pb-4"
      >
        <div className="h-48 flex-col justify-start items-start gap-px flex pt-4 px-4">
          <div className="w-full relative">
            <div className="h-[22px] px-2 py-[3px] right-4 top-0 z-[4] absolute bg-secondary rounded-bl-lg rounded-br-lg justify-center items-center gap-2.5 inline-flex">
              <p className="text-white text-xs font-light leading-none">
                Profile Picture
              </p>
            </div>
          </div>
          <img
            className="h-48 w-48 object-cover relative rounded-xl"
            src={user?.profilePictureSigned}
            alt="dp"
          />
        </div>
        <div className="self-stretch text-center text-white text-3xl font-semibold">
          {user?.firstName} {user?.lastName}
        </div>
      </div>

      <Menu
        className="user-profile-sidebar"
        mode="inline"
        selectedKeys={[selectedKey]}
        openKeys={stateOpenKeys}
        onOpenChange={onOpenChange}
        style={{
          maxHeight: "calc(100vh - 500px)",
          overflowY: "auto",
        }}
        items={renderMenuItems(items)}
      />
    </div>
  );
}



